import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-overlay-component',
  templateUrl: './custom-overlay-component.component.html',
  styleUrls: ['./custom-overlay-component.component.scss']
})
export class CustomOverlayComponentComponent {

}
